export default __webpack_public_path__ + "static/middlebury-logo-259817402b1cc223d9edb223a62c3c73.png";